import { defineComponent as _defineComponent } from 'vue'
import CertificadoService from '@/services/CertificadoService';
import { useMutation } from '@tanstack/vue-query';
import { CertificadoDetalhado, StatusDoCertificado } from '@/../common/types/certificado/Certificado'
import { computed, ref } from 'vue'
import { formatarData } from '@/../common/shareds/formatadores';
import { alert } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogoDeAprovacaoDoCertificado',
  props: {
    value: { type: Boolean },
    certificado: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'change', value: CertificadoDetalhado): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean
  certificado: CertificadoDetalhado
};





const model = computed<boolean>({
  get: () => props.value,
  set: (v) => emit('input', v)
})

const status = ref<StatusDoCertificado>()

function alterarStatusDoCertificado(novoStatus: StatusDoCertificado) {
	status.value = novoStatus
	mutate(novoStatus)
}

const { mutate, isPending } = useMutation({
    mutationFn: (status: StatusDoCertificado) =>
        CertificadoService.patch(props.certificado._id, { status }),
    onSuccess(certificado) {
        emit('change', certificado)
    },
	onError(error) {
		alert.setError(error)
	},
})


return { __sfc: true,props, emit, model, status, alterarStatusDoCertificado, mutate, isPending, formatarData }
}

})